import { baseApi } from "./index";

export const categoryApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCategory: builder.query({
            query: ({ type, locale }) => ({
                url: `category`,
                method: "GET",
                params: {
                    type,
                    locale,
                },
            }),
            providesTags: ["Category"],
        }),
    }),
});

export const {
    useGetCategoryQuery,
} = categoryApi;
